import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  buttonBox: {
    justifyContent: 'end',
  },
  optionTitle: {
    fontWeight: 'bolder',
  },

  optionBox: {
    marginBlock: theme.spacing(1),
  },

  dialogContent: {
    overflow: 'hidden',
  },
  recommended: {
    marginLeft: '1em',
    borderRadius: '4px',
    backgroundColor: theme.palette.lightPastelBlue,
    color: theme.palette.azure,
    fontWeight: 700,
    height: '21px',
  },
  truncatedText: {
    display: 'block',
    maxWidth: '58ch',
  },
}))

export default styles
